// extracted by mini-css-extract-plugin
module.exports = {"DCE5Top":"DCE_DCE5Top__2qVMf","DCE5Bottom":"DCE_DCE5Bottom__ntfI2"};